{
	"version": "1.3",
	"versionCode": 5,
	"geoConfigs": {
		"voyager": {
			"wms":	false,
			"url": 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png',
			"options": {
				"attribution": 'Descarga IFN 1.3 (5) | <a href="https://www.openstreetmap.org/copyright">OSM</a>&<a href="https://stadiamaps.com/attribution">Stadia Maps</a>',
				"minZoom": 9,
				"maxZoom": 16,
				"subdomains": 'abcd'
			}
		},
		"esri": { 
			"wms":	false,
			"url":  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
			"options": {
				"attribution": 'Descarga IFN 1.3 (5) | <a href="https://www.esri.com">Esri</a>',
				"minZoom": 9,
				"maxZoom": 16,
				"subdomains": 'abcd'
			}
		},
		"pnoa": {
			"wms":	true,
			"url":  'http://www.ign.es/wms-inspire/pnoa-ma?SERVICE=WMS&',
			"options": {
				"layers": 'OI.OrthoimageCoverage',
				"format": 'image/jpeg',
				"transparent": true,
				"version": '1.3.0',
				"attribution": 'Descarga IFN 1.3 (5) | <a href="https://pnoa.ign.es/web/portal/pnoa-imagen/presentacion">IGN PNOA</a>'
			}
		}
	},
	"geolocstart": [40.24, -4.24],
	"geoWorldBounds": [ [90, -180], [-90, 180] ],	
	"geoMaxBounds": [ [47, -20], [25, 5] ],
	"geoMaxBoundsViscosity": 1.0,
	
	
	"mapConfig": {
		"mapType": [ "default", "satellite" ],
		"mapDetails": [ "munis", "provs" ]
	},
	"degreesStep6": 8,
	"minAreaStep6": 16000000,
	"zonasValidas": [
		[ [43.795, -9.600], [36.000, 4.500] ],
		[ [29.450, -18.166], [27.636, -13.410] ]
	],
	
	
	"timeout": 8000,
	"timeoutStep": 2000,
	
	
	"zMin": 9,
	"zMax": 16,
	"zRealceMax": {
		"munis": 12,
		"provs": 10
	},
	"zLugar": 12,
	"zCambioRadio": 14,
	"zArbol": 17,	
	

	"firebaseConfig": {
		"apiKey": "AIzaSyCKNozqwyzSGmI078_PD1Lk5kk1g0uTGYg",
		"authDomain": "descarga-ifn.firebaseapp.com",
		"projectId": "descarga-ifn",
		"storageBucket": "descarga-ifn.appspot.com",
		"messagingSenderId": "707091046095",
		"appId": "1:707091046095:web:fea7d06397b48c6e36a1ba",
		"measurementId": "G-VW4T5NS6EH"
	},


	"craftsConfig": {
		"api": 'https://crafts.gsic.uva.es/apis/descifn',
		"auth": 'Bearer 0f2d3e22-389e-49c0-9a43-fe74c8adb77b',
		"queryNopars": '/query?id={{{queryName}}}',		
		"querySubclasses": '/query?id=subclasses&ancestor={{{ancestor}}}',
		"queryCountPlotsPerAllTaxons": '/query?id=countPlotsPerAllTaxons{{#ifn2}}&ifn2=true{{/ifn2}}{{#ifn3}}&ifn3=true{{/ifn3}}',				
		"queryPlotsinbox": '/query?id=plotsinbox{{#ifn2}}&ifn2=true{{/ifn2}}{{#ifn3}}&ifn3=true{{/ifn3}}{{#lngwest}}&lngwest={{{lngwest}}}{{/lngwest}}{{#lngeast}}&lngeast={{{lngeast}}}{{/lngeast}}{{#latnorth}}&latnorth={{{latnorth}}}{{/latnorth}}{{#latsouth}}&latsouth={{{latsouth}}}{{/latsouth}}{{#limit}}&limit={{{limit}}}{{/limit}}{{#offset}}&offset={{{offset}}}{{/offset}}',
		"queryPlotvalues": '/query?id=plotvalues{{#ifn2}}&ifn2=true{{/ifn2}}{{#ifn3}}&ifn3=true{{/ifn3}}{{#piris}}&piris={{{.}}}{{/piris}}{{#limit}}&limit={{{limit}}}{{/limit}}{{#offset}}&offset={{{offset}}}{{/offset}}',
		"resourceTemplate": '/resource?id={{{id}}}&iri={{{iri}}}',
		"resourcesTemplate": '/resources?id={{{id}}}{{#iris}}&iris={{{.}}}{{/iris}}{{#ns}}&ns={{{ns}}}{{/ns}}{{#nspref}}&nspref={{{nspref}}}{{/nspref}}'
	},
	
	"craftsCacheIndex": [
		{ 
			"pref": '/resources?id=',
			"iris": 'iris'
		},
		{ 
			"pref": '/object?id=',
			"iris": 'i'
		},
		{ 
			"pref": '/query?id=plotvalues',
			"iris": 'piris'
		}
	],
	
	"solrConfig": {
		"path": 'https://forestexplorer.gsic.uva.es/lugares',
		"suggestHandler": '/suggest',
		"suggestTemplate": '?q={{{input}}}',
		"selectHandler": '/select',
		"selectTemplate": '?q=id:"{{{id}}}"'
	},
	
	"prefixes": {
		"ifn": 'https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/',
		"pifn2": 'https://datos.iepnb.es/recurso/sector-publico/medio-ambiente/ifn2/plot/',
		"pifn3": 'https://datos.iepnb.es/recurso/sector-publico/medio-ambiente/ifn3/plot/',
		"tifn2": 'https://datos.iepnb.es/recurso/sector-publico/medio-ambiente/ifn2/tree/',
		"tifn3": 'https://datos.iepnb.es/recurso/sector-publico/medio-ambiente/ifn3/tree/',
		"txtop": 'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/',
		"txup23": 'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/',
		"txifn2": 'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/',
		"txifn3": 'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/'
	},
		
	"descifnbase": "http://descargaifn.gsic.uva.es",

	"txPlantae": 'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae',
	"taxonesTop": [
		'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2', 
		'https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1'
	],
	"maxTaxonFilters": 4,
	"ifnVersions": ['ifn2', 'ifn3'],
		
	"treeUri": 'https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Tree',
	
	"maxValuesPlot": {
		"nt": 2000,
		"ba": 50,
		"vwb": 400,
		"vwob": 350
	},	
	
	"radioParcela": 350,
	"radioParcelaN3": 25,
	"ntSatParcela": 1500,
	
	"colores": [
		['#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784', '#66BB6A', '#4CAF50', '#43A047', '#388E3C', '#2E7D32', '#1B5E20'],
		['#FAFAFA', '#F5F5F5', '#EEEEEE', '#E0E0E0', '#BDBDBD', '#9E9E9E', '#757575', '#616161', '#424242', '#212121'],
		['#ECEFF1', '#CFD8DC', '#B0BEC5', '#90A4AE', '#78909C', '#607D8B', '#546E7A', '#455A64', '#37474F', '#263238'],
		['#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D', '#FFA726', '#FF9800', '#FB8C00', '#F57C00', '#EF6C00', '#E65100'],
		['#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1'],

		['#FCE4EC', '#F8BBD0', '#F48FB1', '#F06292', '#EC407A', '#E91E63', '#D81B60', '#C2185B', '#AD1457', '#880E4F'],
		['#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#AB47BC', '#9C27B0', '#8E24AA', '#7B1FA2', '#6A1B9A', '#4A148C'],
		['#E8EAF6', '#C5CAE9', '#9FA8DA', '#7986CB', '#5C6BC0', '#3F51B5', '#3949AB', '#303F9F', '#283593', '#1A237E'],
		['#E0F7FA', '#B2EBF2', '#80DEEA', '#4DD0E1', '#26C6DA', '#00BCD4', '#00ACC1', '#0097A7', '#00838F', '#006064'],
		['#EFEBE9', '#D7CCC8', '#BCAAA4', '#A1887F', '#8D6E63', '#795548', '#6D4C41', '#5D4037', '#4E342E', '#3E2723']
	],
	"colblack": '#000000',
	"coloutext": '#B0BEC5',
	"coloutint": '#B0BEC5',
	"colplotind": 0,
	"colregind": 1,
	"colregselind": 3,
	"colcircplotind": 1,
	"colindefind": 1,
	"coltxinds": [5, 6, 7, 8, 9],
	"colchartinds": [
		[],
		[4],
		[7, 2],
		[8, 5, 2],
		[9, 6, 3, 0],
		[9, 7, 5, 3, 1],		
		[9, 7, 5, 4, 2, 0],		
		[9, 7, 6, 5, 4, 2, 0],
		[8, 7, 6, 5, 4, 3, 2, 1],
		[9, 8, 7, 6, 5, 4, 3, 2, 1],
		[9, 8, 7, 6, 5, 4, 3, 2, 1, 0]		
	],
	
	"langs": ["en", "es"],
	"nolang": "nolang",
	
	"numsugs": 8,
	
	"hidemax": 8,
	"hidebegin": 5,
	
	"interSessionQGap": 432000000,
	"intraSessionQGap": 300000
}